(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ww-h2-campaign"]) return;
  try {
    
(() => {
  const headline = document.getElementById('h2-headline');
  const variant = new URLSearchParams(window.location.search).get('headline') === 'routine' ? 'routine' : 'offer';
  if (variant === 'routine' && headline && headline.dataset.alternative) headline.textContent = headline.dataset.alternative;
  const track = name => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || !privacy.analyticsProcessingAllowed()) return;
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'ww_h2_headline', variant);
        window.clarity('event', 'ww_h2_' + name);
      }
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({event: 'ww_h2_' + name, campaign: 'raspberry_free30', headline_variant: variant});
    } catch (_) {}
  };
  track('offer_view');
  document.addEventListener('visitorConsentCollected', () => track('offer_view'));

  const form = document.getElementById('h2-purchase-form');
  const button = document.getElementById('h2-buy');
  const error = document.getElementById('h2-cart-error');
  if (form && button && !button.disabled) {
    const buttons = Array.from(document.querySelectorAll('[data-h2-buy]'));
    const labels = buttons.map(item => item.innerHTML);
    let pending = false;
    const reset = () => {
      pending = false;
      buttons.forEach((item, index) => {
        item.disabled = false;
        item.removeAttribute('aria-busy');
        item.innerHTML = labels[index];
      });
    };
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending) return;
      pending = true;
      track('bundle_add_attempt');
      buttons.forEach(item => {
        item.disabled = true;
        item.setAttribute('aria-busy', 'true');
        item.textContent = form.dataset.loadingLabel;
      });
      error.hidden = true;
      try {
        const response = await fetch(form.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          body: new FormData(form), headers: {'Accept': 'application/json'}
        });
        if (!response.ok) throw new Error('Cart request failed');
        track('bundle_add_success');
        track('checkout_redirect');
        window.location.assign(form.dataset.checkoutUrl);
      } catch (_) {
        track('bundle_add_error');
        error.hidden = false;
        error.scrollIntoView({block: 'center'});
        reset();
      }
    });
    window.addEventListener('pageshow', reset);
  }
  const offer = document.getElementById('h2-buy');
  const sticky = document.querySelector('.h2-sticky');
  if (offer && sticky && 'IntersectionObserver' in window) new IntersectionObserver(entries => {
    sticky.hidden = entries[0].isIntersecting;
  }, { threshold: 0.1 }).observe(offer);
})();

  } catch(e) { console.error(e); }
})();
})();
